export const GET_SHOPIFY_TOKEN: string = "/shopify/getAccessToken";

export const USER_REGISTER_URL: string = "/shopify/userUpdate";

export const INITIATE_STORE_SETUP: string = "/connector/create";

export const GET_EBAY_TOKEN: string = "/ebay/callback";

export const CARRIER_CONNECT: string = "/shipping/connect";